import { render } from "./ModalAddUpdateProduct.vue?vue&type=template&id=d9478fe4"
import script from "./ModalAddUpdateProduct.vue?vue&type=script&lang=js"
export * from "./ModalAddUpdateProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__